export default __webpack_public_path__ + "static/Deeper-dive-AIDS-2022-dr-jones-725dc58332585d362b1683282e93f73f.png";